@if (data.title) {
  <h2 mat-dialog-title>{{ data.title }}</h2>
}
<mat-dialog-content>
  <p>{{ data.message }}</p>
  </mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="onOk()">{{ data.okText || 'Ok' }}</button>
</mat-dialog-actions>


